import React from "react";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "config/theme";
import { client } from "config/client";
import AppRouter from "routes/app-router";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";

export const App = () => (
  <HelmetProvider>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <Toaster position="top-right" reverseOrder />
        <CssBaseline />
        <AppRouter />
      </ThemeProvider>
    </ApolloProvider>
  </HelmetProvider>
);

export default App;
